import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

const selectBookingsState = (state: RootState) => state.bookingsList;

export const selectBookingsRows = createSelector(
  [selectBookingsState],
  (state) => state.rows,
);

export const selectBookingsLoading = createSelector(
  [selectBookingsState],
  (state) => state.loading,
);

export const selectBookingsError = createSelector(
  [selectBookingsState],
  (state) => state.error,
);

export const selectBookingsSortOrder = createSelector(
  [selectBookingsState],
  (state) => state.sortingOrder,
);

export const selectBookingsSortField = createSelector(
  [selectBookingsState],
  (state) => state.sortingField,
);

export const selectBookingsSearch = createSelector(
  [selectBookingsState],
  (state) => state.search,
);

export const selectBookingsTotal = createSelector(
  [selectBookingsState],
  (state) => state.totalBookings,
);

export const selectBookingsFromIndex = createSelector(
  [selectBookingsState],
  (state) => state.fromIndex,
);

export const selectBookingsCustomerFilterIds = createSelector(
  [selectBookingsState],
  (state) => state.customerFilterIds,
);

export const selectBookingsCarrierFilterIds = createSelector(
  [selectBookingsState],
  (state) => state.carrierFilterIds,
);

export const selectBookingsStatusFilterValues = createSelector(
  [selectBookingsState],
  (state) => state.statusFilterValues,
);

export const selectBookingsBookingTypeFilterValues = createSelector(
  [selectBookingsState],
  (state) => state.bookingTypeFilterValues,
);

export const selectBookingsLocationFilterIds = createSelector(
  [selectBookingsState],
  (state) => state.locationFilterIds,
);
